"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createValidity;
function createValidity(key) {
  return {
    key: key,
    isValid: true
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/utils/createValidity.js
// module id = 1883
// module chunks = 0